import React, { useState } from "react";
import * as Yup from "yup";
import { FormControl, InputLabel, TextField } from "@mui/material";
import AuthBoxHeader from "../../components/authentication/AuthBoxHeader";
// import GoBack from "../../components/authentication/GoBack";
import AuthLayout from "src/layouts/AuthLayout";
import { Field, Form, FormikProvider, useFormik } from "formik";
import authStores from "../../contexts/AuthProvider";
import { useNavigate } from "react-router";
import { useSnackbar } from "notistack";
import { LoadingButton } from '@mui/lab';

const ForgotPassword = () => {
  const authStore = authStores();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [resetPasswordByEmail, setResetPasswordByEmail] = useState(true); //Toggle between Login options
  const [buttonLoading, setButtonLoding] = useState(false);

  const completedSchema = Yup.object().shape({
    email: Yup.string().email("Email must be a valid email address").required("Email is required"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      device: "",
    },
    validationSchema: completedSchema,
    onSubmit: async (values, { resetForm }) => {
      const informationObj = {
        email: values.email,
        device: 3,
        reason: "forgetPassword",
      };
      const userData = {
        userEmail: values.email,
        verify: "forgetPassword",
      };
      setButtonLoding(true)
      const [success, error] = await authStore.getOtp(informationObj);
      if (success) {
        setButtonLoding(false)
        navigate("/otp-verification", { state: userData });
        resetForm();
        enqueueSnackbar(success, {
          variant: "success",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 2000,
        });
      } else {
        setButtonLoding(false)
        enqueueSnackbar(error.message, {
          variant: "error",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 2000,
        });
      }
    },
  });
  const { errors, touched, handleSubmit, getFieldProps } = formik;

  // const hanleNavigate = () => {
  //   navigate(-1);
  // };

  // const changeLoginOption = () => {
  //    setResetPasswordByEmail(!resetPasswordByEmail);
  //    formik.resetForm();
  // };

  return (
    <>
      <AuthLayout>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <div className="auth_box">
              {/* Authentication title and instruction */}
              <AuthBoxHeader title={"Reset Password"} instruction={"Enter your email to receive password reset instructions"} />
              {!resetPasswordByEmail ? (
                <>
                  <Field customeName="phone" name="phone" errors={errors.phone} />
                </>
              ) : (
                <FormControl className="form-control-custom" sx={{
                  marginBottom: "16px", "&.form-control-custom .MuiFormLabel-root": {
                    position: "unset",
                    transform: "unset",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#333230",
                    marginBottom: "6px"
                  }
                }}>
                  <InputLabel htmlFor="my-input">Email</InputLabel>
                <TextField id="resetPasswordInputEmail"  sx={{
                      "&.MuiTextField-root": {
                        margin: "0px !Important",
                        "& .MuiFormHelperText-root": {
                          marginLeft: "0px !important",
                          marginRight: "0px !important"
                        },
                        "& .MuiInputBase-root": {
                          padding: "14px 24px",
                          border: "1px solid #BDBDBD",
                          borderRadius: "8px",
                          backgroundColor: "#ffffff",
                          "&.Mui-error": {
                            border: "1px solid #d32f2f",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                          "& .MuiInputBase-input": {
                            padding: "0px",
                            background: "none",
                            borderRadius: "0px",
                            fontSize: "14px",
                            fontWeight: "500"
                          },
                        }
                      },
                    }}hiddenLabel type="email" autoComplete="off" fullWidth variant="outlined" margin="normal" {...getFieldProps("email")} error={Boolean(touched.email && errors.email)} helperText={touched.email && errors.email} />
      
                </FormControl>
              )}

              <LoadingButton
                type='submit'
                fullWidth
                className="mt-4 text-capitalize text-white app_text_16_semibold app_btn_lg"
                loading={buttonLoading}
                loadingPosition="end"
                variant="contained"
                sx={{
                  backgroundColor: "#FFBD05", boxShadow: "none" ,borderRadius: "8px", "&:hover": {
                    backgroundColor: "#FFBD05",
                    boxShadow: "none",
                  }
                }}
              >
                Next
              </LoadingButton>
              {/* <Button
                        onClick={changeLoginOption}
                        className="mt-3 app_btn_lg app_border_primary app_text_16_semibold app_text_primary"
                        sx={{ textTransform: "none" }}
                        startIcon={resetPasswordByEmail ? <PhoneCircle /> : <EmailCircle />}
                        fullWidth
                        variant="outlined"
                     >
                        {!resetPasswordByEmail ? "Reset Password with mail" : "Reset Password with phone number"}
                     </Button> */}
            </div>
          </Form>
        </FormikProvider>
      </AuthLayout>
    </>
  );
};

export default ForgotPassword;
